import { Miniature } from '../../../models/miniature';

export const FloatMiniature: Miniature = {
    type: 'Float',
    title: 'Tag',
    icon: 'fa-tag',
    highlights: ['A new tag'],
    create: () => {},
    group: '',
    sortingOrder: 0
};